// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/model_registry.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { ModelRegistryService } from "./model_registry_pb";

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.ListModels
 */
export const listModels = ModelRegistryService.method.listModels;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModel
 */
export const getModel = ModelRegistryService.method.getModel;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModel
 */
export const createModel = ModelRegistryService.method.createModel;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.UpdateModel
 */
export const updateModel = ModelRegistryService.method.updateModel;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.DeleteModel
 */
export const deleteModel = ModelRegistryService.method.deleteModel;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.ListModelVersions
 */
export const listModelVersions = ModelRegistryService.method.listModelVersions;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelVersion
 */
export const getModelVersion = ModelRegistryService.method.getModelVersion;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelVersion
 */
export const createModelVersion = ModelRegistryService.method.createModelVersion;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelArtifact
 */
export const createModelArtifact = ModelRegistryService.method.createModelArtifact;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.CreateModelVersionFromArtifact
 */
export const createModelVersionFromArtifact = ModelRegistryService.method.createModelVersionFromArtifact;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.UpdateModelVersion
 */
export const updateModelVersion = ModelRegistryService.method.updateModelVersion;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.DeleteModelVersion
 */
export const deleteModelVersion = ModelRegistryService.method.deleteModelVersion;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.DownloadModelArtifact
 */
export const downloadModelArtifact = ModelRegistryService.method.downloadModelArtifact;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelReferences
 */
export const getModelReferences = ModelRegistryService.method.getModelReferences;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelReference
 */
export const getModelReference = ModelRegistryService.method.getModelReference;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelArtifactUploadUrls
 */
export const getModelArtifactUploadUrls = ModelRegistryService.method.getModelArtifactUploadUrls;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.ListModelArtifacts
 */
export const listModelArtifacts = ModelRegistryService.method.listModelArtifacts;

/**
 * @generated from rpc chalk.server.v1.ModelRegistryService.GetModelArtifact
 */
export const getModelArtifact = ModelRegistryService.method.getModelArtifact;
